export enum RoleEnum {
    THIRD_PARTY_SHIPMENT = 'ROLE_THIRD_PARTY_SHIPMENT',
    EDIT_CONTACTS = 'ROLE_EDIT_CONTACTS',
    CREATE_SHIPMENTS = 'ROLE_CREATE_SHIPMENTS',
    MANIFEST_SHIPMENTS = 'ROLE_MANIFEST_SHIPMENTS',
    CREDIT_CARD_PAYMENTS = 'ROLE_CREDIT_CARD_PAYMENTS',
    PACKAGE_LIBRARY = 'ROLE_PACKAGE_LIBRARY',
    VIEW_TRANSACTIONS = 'ROLE_VIEW_TRANSACTIONS',
    VIEW_ADDRESS_BOOKS = 'ROLE_VIEW_ADDRESS_BOOKS',
    OPEN_PICKUP = 'ROLE_OPEN_PICKUP'
}
